// extracted by mini-css-extract-plugin
export var checkbox = "_77-0";
export var circle = "_77-3";
export var horizontalContainer = "_77-7";
export var sm = "_77-5";
export var switch0 = "_77-2";
export var switchDisabled = "_77-8";
export var switchEnabled = "_77-1";
export var textSwitchContainer = "_77-9";
export var textSwitchOption = "_77-a";
export var textSwitchOptionSelected = "_77-b";
export var verticalContainer = "_77-6";
export var xs = "_77-4";